// @flow
import {CENTRIFUGE_ACTION_TYPES} from 'modules/centrifuge/constants';
import {createReducer} from 'modules/redux/reducer';

export type TCentrifugeConnectionData = {
    timestamp: string,
    token: string,
    url: string,
    user: string,
};
export type TCentrifugeState = {
    connectionData: ?TCentrifugeConnectionData,
    connectionInProcess: boolean,
    isConnected: boolean,
};
const initialState: TCentrifugeState = {
    connectionData: null,
    connectionInProcess: false,
    isConnected: false,
};

export type TActionSetIsConnected = {
    payload: boolean,
    type: typeof CENTRIFUGE_ACTION_TYPES.CENTRIFUGE_SET_IS_CONNECTED,
};

export type TActionSetConnectionData = {
    payload: boolean,
    type: typeof CENTRIFUGE_ACTION_TYPES.CENTRIFUGE_SET_CONNECTION_DATA,
};

export type TActionConnectionInProcess = {
    payload: boolean,
    type: typeof CENTRIFUGE_ACTION_TYPES.CENTRIFUGE_SET_IN_PROGRESS,
};

const reducer = {
    [CENTRIFUGE_ACTION_TYPES.CENTRIFUGE_SET_IN_PROGRESS]: (state, payload: boolean) => {
        return {
            ...state,
            connectionInProcess: payload,
        };
    },
    [CENTRIFUGE_ACTION_TYPES.CENTRIFUGE_SET_IS_CONNECTED]: (state, payload: boolean) => {
        return {
            ...state,
            isConnected: payload,
        };
    },
    [CENTRIFUGE_ACTION_TYPES.CENTRIFUGE_SET_CONNECTION_DATA]: (state, payload: TCentrifugeConnectionData) => {
        return {
            ...state,
            connectionData: payload,
        };
    },
};

export const centrifugeReducer = createReducer(initialState, reducer);
